import ocr from 'common/service/ocr';
import artist from 'common/service/artist';
import artistV2 from 'common/service/artistV2';
import upload from 'common/service/upload';
import userSetting from 'common/service/userSetting';
import biddingTasks from 'common/service/biddingTasks';
import taskVersionServer from 'common/service/taskVersionServer';
import workV2 from 'common/service/workV2';
import taskV2 from 'common/service/taskV2';

import danqing from 'common/service/danqing';
import yusheng from 'common/service/yusheng';
import dccServer from 'common/service/dccServer';
import tasks from 'common/service/tasks';
import uploadByPreSign from 'common/service/uploadByPreSign';
import project from 'common/service/project';
import order from 'common/service/order';
import contract from 'common/service/contract';
import { recommendedTools } from './recommendedTools';
import { recommend } from './recommend';
import { backendUser } from './backendUser';

import * as system from './system';
import * as chunkUploads from './chunkUploads';
import * as workshop from './workshop';
import * as activity from './activity';
import * as feedback from './feedback';
export * from './utils/tools';
import time from './time';
import aliyun from './aliyun';

const service = {
  ocr,
  artist,
  artistV2,
  upload,
  userSetting,
  biddingTasks,
  taskVersionServer,
  danqing,
  yusheng,
  dccServer,
  workV2,
  taskV2,
  tasks,
  uploadByPreSign,
  project,
  order,
  chunkUploads,
  contract,
  recommendedTools,
  recommend,
  backendUser,

  system,
  workshop,
  activity,
  feedback,
  time,
  aliyun,
};
export default service;
